export { InsertButton } from "src/components/LinkWorkoutItemsInsertButton";
import { type WorkoutFormat } from "api-client/legacy-trpc";
import { observer } from "mobx-react-lite";

import { LinkButtonGroup } from "src/components/LinkWorkoutItemsButtonGroup";
import { UnlinkButtonGroup } from "src/components/UnlinkWorkoutItemsButtonGroup";
import { type TranslationKey } from "src/types";

import { useWorkoutEditStore } from "./WorkoutEditContext";

interface LinkUnlinkWorkoutItemsButtonProps {
  itemId: string;
  previousItemId: string;
  onInsert: () => void;
  sections: SectionFormatOption[];
  onAddSection: (format: WorkoutFormat) => void;
  onImportFromLibrary?: () => void;
}

export type SectionFormatOption = {
  format: WorkoutFormat;
  labelKey: TranslationKey;
};

export const LinkUnlinkWorkoutItemsButton = observer(
  function LinkUnlinkWorkoutItemsButton(
    props: LinkUnlinkWorkoutItemsButtonProps,
  ) {
    const workoutEditStore = useWorkoutEditStore();
    const isInsideSuperset = workoutEditStore.isInsideSuperset(props.itemId);

    if (isInsideSuperset) {
      return (
        <UnlinkButtonGroup
          itemId={props.itemId}
          previousItemId={props.previousItemId}
          onInsert={props.onInsert}
          sections={props.sections}
          onAddSection={props.onAddSection}
          onImportFromLibrary={props.onImportFromLibrary}
        />
      );
    }

    return (
      <LinkButtonGroup
        itemId={props.previousItemId}
        onInsert={props.onInsert}
        sections={props.sections}
        onAddSection={props.onAddSection}
        onImportFromLibrary={props.onImportFromLibrary}
      />
    );
  },
);
export interface InsertButtonProps {
  onInsert: () => void;
  sections: SectionFormatOption[];
  onAddSection: (format: WorkoutFormat) => void;
  onImportFromLibrary?: () => void;
}
export interface LinkButtonGroupProps {
  itemId: string;
  onInsert: () => void;
  sections: SectionFormatOption[];
  onAddSection: (format: WorkoutFormat) => void;
  onImportFromLibrary?: () => void;
}
export interface UnlinkButtonGroupProps {
  itemId: string;
  previousItemId: string;
  onInsert: () => void;
  sections: SectionFormatOption[];
  onAddSection: (format: WorkoutFormat) => void;
  onImportFromLibrary?: () => void;
}
